var app = angular.module('leonardo');

var WhiteLabelService = function(BaseRestService, $q, RestangularProvider, ConfigThemeService, Upload, NotificationService) {
  var service = new BaseRestService('whitelabels');

  service.STATUS_PENDING = '0';
  service.STATUS_ACTIVE = '1';
  service.STATUS_ON_BOARDING = '2';
  service.STATUS_REJECTED = '3';

  service.STATUS_OPTIONS = [
    {id: service.STATUS_PENDING, name: 'Pending'},
    {id: service.STATUS_ACTIVE, name: 'Active'},
    {id: service.STATUS_ON_BOARDING, name: 'On Boarding'},
    {id: service.STATUS_REJECTED, name: 'Rejected'}
  ];

  service.getBillingReports = function(params) {
    var defer = $q.defer();
    RestangularProvider.all('whitelabels').customGET('report/billing', params).then(function(data){
      defer.resolve(data);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getStatuses = function() {
    return [
      service.STATUS_PENDING,
      service.STATUS_ACTIVE,
      service.STATUS_ON_BOARDING,
      service.STATUS_REJECTED
    ];
  };

  service.activate = function(account, sector, name) {
    var data = {
      sector: sector,
      name: name
    };
    return account.customPOST(data, 'activate');
  };

  service.reject = function(account) {
    return account.customPOST({}, 'reject');
  };

  service.onboardingFinished = function(account) {
    return account.customPOST({}, 'onboarding-finished');
  };

  service.post = function(params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/whitelabels/'),
      arrayKey: '',
      data: params
    }, function(error) {
      NotificationService.error(error);
    });
  };

  service.patch = function(id, params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/whitelabels/' + id + '/'),
      arrayKey: '',
      data: params,
      method: 'PUT'
    }, function(error) {
      NotificationService.error(error);
    });
  };

  service.bulkObject = function() {
    return {
      theme_config: ConfigThemeService.config.theme_config,
      url_config: {},
      maximum_account_permissions: {},
      default_account_permissions: {},
      admin_permissions: {}
    };
  };

  return service;
};

app.factory('WhiteLabelService', ['BaseRestService', '$q', 'Restangular', 'ConfigThemeService', 'Upload',
  'NotificationService', WhiteLabelService]);
